var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
        'ldc-select-show-option mb-2 px-2': true,
        'd-flex flex-wrap': _vm.labelPosition == 'left'
    }},[(_vm.showPlaceholder)?_c('div',{class:{
        'title-select py-2 mt-2': true,
        'mr-2': _vm.labelPosition == 'left'
    }},[_vm._v(_vm._s(_vm.placeholder)+":")]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }